const fonts = {
  sans: '"Neue Haas Grotesque", sans-serif',
  serif: '"Ogg Roman", serif',
  slant: '"Ogg Slant", serif',
};

export default fonts;
